/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Link} from 'react-router-dom'
import {useAuth} from '../../../../app/modules/auth'
import { toAbsoluteUrl } from '../../../helpers'


export const HOME_URL = process.env.REACT_APP_HOME_URL

const HeaderUserMenu: FC = () => {
  const {currentUser, logout} = useAuth()
  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
      style={{background: '#1c1c0d'}}
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
          <img
            src={HOME_URL + currentUser?.profilePicture?.filePath}
            alt={`${currentUser?.name}'s profile`}
            onError={(e) => (e.currentTarget.src = toAbsoluteUrl('/media/avatars/default-user.png'))}
            />
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>
              {currentUser?.name}
              <span className='badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2'>
                {currentUser?.role || 'Admin'}
              </span>
            </div>
            <a href='#' className='fw-bold fs-7' style={{color: '#ce8d3b'}}>
              {currentUser?.email}
            </a>
          </div>
        </div>
      </div>
      <div className='menu-item px-5 my-1'>
        <Link to='/crafted/account/settings' className='menu-link px-5' style={{color: 'white'}}>
          Contul meu
        </Link>
      </div>

      <div className='menu-item px-5'>
        <a onClick={logout} className='menu-link px-5' style={{color: 'white'}}>
          Deconectare
        </a>
      </div>
    </div>
  )
}

export {HeaderUserMenu}
